export const uploadFile = async ({
  key,
  acl = 'public-read',
  policy,
  accessKeyId,
  signature,
  file,
  url,
  bucket,
}) => {
  const formData = new FormData();

  formData.append('key', key);
  formData.append('acl', acl);
  formData.append('Content-Type', file.type);
  formData.append('policy', policy);
  formData.append('AWSAccessKeyId', accessKeyId);
  formData.append('signature', signature);
  formData.append('file', file);

  const data = await fetch(url, {
    method: 'post',
    body: formData,
  });
  if (!data.ok) return Promise.reject(data);
  return Promise.resolve({
    bucket,
    key,
    location: `${url}${key}`,
    status: data.status,
  });
};
